import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../services/authService';

export default function ProtectedRoute({ children }) {
  const [checking, setChecking] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const authTimeout = setTimeout(() => {
      if (isMounted) {
        console.warn('Auth check timed out');
        setAuthenticated(false);
        setChecking(false);
      }
    }, 5000);

    (async () => {
      try {
        const isAuth = await isAuthenticated();
        if (isMounted) {
          setAuthenticated(isAuth);
          setChecking(false);
        }
      } finally {
        clearTimeout(authTimeout);
      }
    })();

    return () => {
      isMounted = false;
      clearTimeout(authTimeout);
    };
  }, []);

  if (checking) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        fontSize: '1.2rem',
        color: 'var(--text)'
      }}>
        🔒 Überprüfe Berechtigung...
      </div>
    );
  }

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
